/* src/app/code-detail/code-detail.component.scss */
.form-group {
  text-align: left;
}
.editCode {
  background: white;
  padding: 20px;
  border-radius: 8px;
  color: black;
}
.editCode input,
.editCode select,
.editCode textarea {
  color: black !important;
  background-color: white !important;
  border: 1px solid #ccc;
  font-size: 1rem;
  height: 30px;
  padding: 2px 5px;
}
.editCode ::ng-deep .mat-mdc-select-value {
  color: black !important;
  padding-left: 8px;
}
.editCode ::ng-deep .mat-mdc-select-arrow-wrapper {
  padding-right: 8px;
}
.editCode ::ng-deep .mat-mdc-form-field-infix {
  min-height: 30px !important;
  padding-top: 4px !important;
  padding-bottom: 0px !important;
}
.editCode ::ng-deep .mat-mdc-text-field-wrapper {
  height: 30px !important;
  padding-top: 0px !important;
}
.invalid-feedback {
  display: block;
}
.selector {
  width: 100%;
}
.error {
  background-color: red;
  padding: 2px;
  color: white;
  text-align: center;
  border-radius: 5px;
}
.code-header {
  display: flex;
  justify-content: right;
  margin-bottom: 1em;
  font-size: 2em;
  font-weight: bold;
}
.using-stencil {
  text-align: left;
  margin-bottom: 10px;
}
/*# sourceMappingURL=code-detail.component.css.map */
